import * as React from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import { useEffect } from "react";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/clone-list");
    }
  }, [navigate]);


  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const form = { username, password };
      const res = await ApiService.post("/cms/auth", form);

      localStorage.setItem("token", res.token);

      toast.success("You’ve successfully logged in!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setTimeout(() => navigate("/clone-list"), 2100);
    } catch (err) {
      console.error("Error during login:", err);
      setError(err.message);

      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin(e);
    }
  };

  return (
    <div className="tyn-root">
      <div className="tyn-content tyn-auth tyn-auth-centered">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-5 col-md-7 col-sm-9">
              <div className="card border-0 py-4">
                <div className="my-3 text-center d-flex align-items-center justify-content-center">
                  <Link className="tyn-logo tyn-logo-sm" to="/">
                    <img
                      src="/images/logo/bardo-icon.png"
                      alt="Bardo logo"
                      className="logo-icon"
                    />
                    <img
                      src="/images/logo/bardo-text.png"
                      alt="Bardo logo"
                      className="logo-text"
                    />
                  </Link>
                </div>
                <div className="p-4">
                  <h3>Login</h3>
                  {error && <p className="text-danger small">{error}</p>}
                  <form className="row g-3" onSubmit={handleLogin}>
                    <div className="col-12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="email-address">
                          Email Address
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            id="email-address"
                            placeholder="youremail@example.com"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label className="form-label d-flex" htmlFor="password">
                          Password
                          <Link
                            to="/forgot-password"
                            className="link link-primary ms-auto"
                          >
                            Forgot?
                          </Link>
                        </label>
                        <div className="form-control-wrap position-relative">
                          <input
                            type={!showPassword ? "text" : "password"}
                            className="form-control"
                            id="password"
                            placeholder="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                          <span
                            className="position-absolute end-0 top-50 translate-middle-y pe-3 cursor-pointer"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i
                              className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"
                                }`}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        onClick={handleLogin}
                        disabled={loading}
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="text-center mt-3 my-3 ">
                  <p>
                    Don't have an account?{" "}
                    <Link
                      to="/sign-up"
                      className="link link-primary"
                      style={{ fontSize: "16px" }}
                    >
                      Sign Up.
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
